import React from "react";
import { Link } from "react-router-dom";
import NotFoundImg from "../../assets/images/startman.svg";

const AccessBlocked = () => {
  return (
    <React.Fragment>
      <div className="text-center">
        <div
          className="d-flex align-items-center justify-content-center"
          style={{ height: "100vh" }}
        >
          <div className="col col-lg-4 text-center">
            <img src={NotFoundImg} height="90" alt="akses-ditolak" />
            <h1 className="text-error mt-4">403</h1>
            <h4 className="text-uppercase text-danger mt-3">Akses Ditolak</h4>
            <p className="text-muted mt-3">
              Maaf anda tidak bisa memasuki halaman tersebut !
            </p>

            <Link className="btn btn-primary mt-3" to="/">
              <i className="mdi mdi-reply"></i> Kembali ke Login
            </Link>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default AccessBlocked;
